import { fetchWrapper } from '@/_helpers';

const getExternalEventsQuery = (options) => {
    const params = new URLSearchParams();
    const limit = Number.isFinite(options.limit) ? options.limit : 50;
    params.append('limit', limit);
    if (options.page) params.append('page', options.page);
    if (options.calendarProvider && options.calendarProvider !== 'all') {
        params.append('calendarProvider', options.calendarProvider);
    }
    if (options.searchText && typeof options.searchText === 'string' && options.searchText.trim()) {
        params.append('searchText', options.searchText.trim());
    }
    return params.toString();
};

async function getEvents(options = {}) {
    const queryParams = getExternalEventsQuery(options);
    return fetchWrapper.get(`/calendar-integrations/external-calendar-events?${queryParams}`);
}

async function getEvent(id) {
    return fetchWrapper.get(`/calendar-integrations/external-calendar-events/${id}`);
}

async function getEventByOriginalId(externalEventOriginalId) {
    return fetchWrapper.get(`/calendar-integrations/external-calendar-events/original/${externalEventOriginalId}`);
}

async function bulkCopyToOptonome(payload = {}) {
    return fetchWrapper.post(`/calendar-integrations/external-calendar-events/copy-to-optonome`, payload);
}

async function updateVisibility(id, hideFromCalendar) {
    return fetchWrapper.patch(`/calendar-integrations/external-calendar-events/${id}/visibility`, { hideFromCalendar });
}

async function getCopiedTasks(id) {
    return fetchWrapper.get(`/calendar-integrations/external-calendar-events/${id}/copied-tasks`);
}

export const externalCalendarEventApi = {
    getEvents,
    getEvent,
    getEventByOriginalId,
    bulkCopyToOptonome,
    updateVisibility,
    getCopiedTasks,
};
